export default __webpack_public_path__ + "static/media/theme-graphite.55230026.png";